var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright wid1100"},[_c('p',[_vm._v(_vm._s(_vm.$t('footer.disclaimer')))]),_c('p',[_vm._v(_vm._s(_vm.$t('footer.copyright')))])]),_c('el-backtop',{attrs:{"visibility-height":100,"right":20,"bottom":20}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }